import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/douyin/2025-03/Index.vue')
const IndexUNI = () => import('../activity/douyin/2025-03-uni/Index.vue')
const RankingUNI = () => import('../activity/douyin/2025-03-uni/Ranking.vue')
const IndexUNIChooseSchool = () => import('../activity/douyin/2025-03-uni/ChooseSchool.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/douyin/2025-03',
  name: 'activity_douyin_2025_03',
  component: Index,
  meta: {
    title: '天天跳绳种草官',
  },
}

export const indexUNIRoute: RouteConfig = {
  path: '/activity/douyin/2025-03-uni',
  name: 'activity_douyin_2025_03_uni',
  component: IndexUNI,
  meta: {
    title: '宿舍体感挑战赛',
  },
}

export const rankingUNIRoute: RouteConfig = {
  path: '/activity/douyin/2025-03-uni/ranking',
  name: 'activity_douyin_2025_03_uni_ranking',
  component: RankingUNI,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '宿舍体感挑战赛-排行榜',
  },
}

export const indexUNIChooseSchoolRoute: RouteConfig = {
  path: '/activity/douyin/2025-03-uni/choose-school',
  name: 'activity_douyin_2025_03_uni_choose_school',
  component: IndexUNIChooseSchool,
  meta: {
    title: '宿舍体感挑战赛-选择学校',
  },
}

export default [indexRoute, indexUNIRoute, rankingUNIRoute, indexUNIChooseSchoolRoute]
